import { render, staticRenderFns } from "./ConversationsView.vue?vue&type=template&id=23de9d3e&scoped=true&"
import script from "./ConversationsView.vue?vue&type=script&lang=ts&"
export * from "./ConversationsView.vue?vue&type=script&lang=ts&"
import style0 from "./ConversationsView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ConversationsView.vue?vue&type=style&index=1&id=23de9d3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de9d3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSkeletonLoader,VSnackbar})
